// extracted by mini-css-extract-plugin
export default {"taxDisclaimer":"Transactions_taxDisclaimer__ip1HA"};